<template>
    <div class="title">
        <div class="t-left">
            <div class="l-top">
                <p class="text">{{ title }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'template.textTitle-temp3',
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
        };
    },
    watch: {},
    methods: {},
    mounted() { },
};
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YouSheBiaoTiHei";
    src: url("../../assets/fonts/YouSheBiaoTiHei.woff2");
}

.title {
    width: 435px;
    height: 40px;
}

.t-left {
    .l-top {
        width: 435px;
        height: 37.5px;
        background: url('../../assets/template3/title.png') no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 3px 0 0 60px;

        .text {
            font-family: YouSheBiaoTiHei;
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
        }
    }
}
</style>